// Contracts — Telegram-бот команды (`weern-tgbot`, ADR-0052).
//
// Два разных входа, оба недоверенные, оба обязаны проверяться рантайм-схемой:
//   1. апдейт от Telegram — чужой сервис, форма которого нам не подчиняется;
//   2. подтверждение от демона на машине — свой, но за пределами воркера.
//
// Апдейт разбираем ТЕРПИМО: Telegram добавляет поля молча, и падать на
// незнакомом ключе значит терять сообщения живых людей. Поэтому объекты
// passthrough и почти всё опционально — схема проверяет то, на что мы реально
// смотрим (кто, где, что написал), а не весь их протокол.
import { z } from 'zod';

export const TgUserSchema = z.object({
  id: z.number(),
  username: z.string().optional(),
  first_name: z.string().optional(),
}).passthrough();
export type TgUser = z.infer<typeof TgUserSchema>;

export const TgChatSchema = z.object({
  id: z.number(),
  type: z.string(),
  title: z.string().optional(),
}).passthrough();
export type TgChat = z.infer<typeof TgChatSchema>;

export const TgMessageSchema = z.object({
  message_id: z.number(),
  from: TgUserSchema.optional(),
  chat: TgChatSchema,
  text: z.string().optional(),
  caption: z.string().optional(),
  date: z.number().optional(),
  // Вложения: ресерчер кидает материал прямо в чат. Фото приходит массивом
  // размеров — нужен последний (самый крупный), остальные это превью.
  photo: z.array(z.object({
    file_id: z.string(),
    file_unique_id: z.string().optional(),
    width: z.number().optional(),
    height: z.number().optional(),
    file_size: z.number().optional(),
  }).passthrough()).optional(),
  document: z.object({
    file_id: z.string(),
    file_name: z.string().optional(),
    mime_type: z.string().optional(),
    file_size: z.number().optional(),
  }).passthrough().optional(),
  media_group_id: z.string().optional(),
}).passthrough();
export type TgMessage = z.infer<typeof TgMessageSchema>;

export const TgUpdateSchema = z.object({
  update_id: z.number(),
  message: TgMessageSchema.optional(),
  edited_message: TgMessageSchema.optional(),
  callback_query: z.object({
    id: z.string(),
    from: TgUserSchema,
    data: z.string().optional(),
    message: TgMessageSchema.optional(),
  }).passthrough().optional(),
}).passthrough();
export type TgUpdate = z.infer<typeof TgUpdateSchema>;

// ── очередь команд владельца (демон на машине) ───────────────────────────────

export const TgPendingCommandSchema = z.object({
  id: z.string(),
  chat_id: z.string(),
  text: z.string(),
  kind: z.string(),
  created_at: z.string(),
});
export type TgPendingCommand = z.infer<typeof TgPendingCommandSchema>;

export const TgPendingResSchema = z.object({
  ok: z.boolean(),
  commands: z.array(TgPendingCommandSchema),
});
export type TgPendingRes = z.infer<typeof TgPendingResSchema>;

// `result` режем схемой, а не в обработчике: демон гонит туда вывод чужих
// команд, и лимит должен стоять на границе, а не в SQL-бинде.
export const TgAckReqSchema = z.object({
  id: z.string().trim().min(1).max(64),
  result: z.string().max(2000).optional(),
  failed: z.boolean().optional(),
});
export type TgAckReq = z.infer<typeof TgAckReqSchema>;

export const TgAckResSchema = z.object({ ok: z.boolean() });
export type TgAckRes = z.infer<typeof TgAckResSchema>;
